import NavActionTypes from "./nav.types";

const INITIAL_STATE = {
  section: null,
  isOverGallery: false,
};

const navReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NavActionTypes.SCROLL_TO_SECTION:
      return {
        ...state,
        section: action.payload,
      };
    case NavActionTypes.SET_OVER_GALLERY:
      return {
        ...state,
        isOverGallery: action.payload,
      };
    default:
      return state;
  }
};

export default navReducer;
